import React from 'react';
import { Portfolio } from '../components/Portfolio';
import { Reviews } from '../components/Reviews';
import { Link } from 'react-router-dom';
import './PortfolioPage.css';

const PortfolioPage = () => {
  return (
    <div className="portfolio-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Our Portfolio</h1>
          <p className="page-description">
            Explore our collection of completed projects across various genres and styles
          </p>
        </div>
      </div>
      <Portfolio />
      <Reviews />
      
      {/* CTA Section */}
      <section className="portfolio-cta section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Start Your Project?</h2>
            <p className="cta-description">
              Let's create something amazing together
            </p>
            <Link to="/booking" className="btn btn-primary btn-large">
              Book Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;